import { Button, Col, Form, Input, Layout, notification, Row, Spin } from 'antd';
import React, { useEffect, useRef, useState } from 'react'
import HeaderFile from './Layout/HeaderFile';
import TextArea from 'antd/es/input/TextArea';
import { MailFilled, PhoneFilled, PushpinOutlined, RightCircleFilled, SearchOutlined } from '@ant-design/icons';
import FooterFile from './Layout/FooterFile';
import axios from 'axios';
import SmoothScrollProvider from './Layout/SmoothScrollProvider';
import BlurText from './Layout/BlurText';
import { ParallaxBanner } from 'react-scroll-parallax';
import ContactForm from './Layout/ContactForm';


const { Header, Content, Footer } = Layout;

const Contact = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const [api, contextHolder] = notification.useNotification();
  const openNotification = (type, message, description) => {
    api[type]({
      message,
      description,
      placement: 'topRight',
    });
  };


    const [position, setPosition] = useState('end');


        const [isMobile, setIsMobile] = useState(window.innerWidth);
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth < 770); // Set breakpoint for mobile
          };

          handleResize(); // Set initial state
          window.addEventListener("resize", handleResize);

          return () => {
            window.removeEventListener("resize", handleResize);
          };
        }, []);

        const onFinish = async (values) => {
          setLoading(true); 
          try {
            const response = await axios.post('https://kavintechcorp.in/mouna_wp/wp-json/custom-api/v1/submit-contact', {
              first_name: values.first_name,
              last_name: values.last_name,
              email: values.email,
              contact_number: values.contact_number,
              message: values.message,
            });
      
            console.log('Response:', response.data);
            openNotification('success', 'Success', 'Form submitted successfully!');

            form.resetFields(); 
          } catch (error) {
            console.error('Error:', error);
            // Handle error, like showing an error message
            openNotification('error', 'Error', 'Failed to submit the form. Please try again.');

          } finally {
            setLoading(false); // Stop loader
          }
        };



  return (
    <div >
      <SmoothScrollProvider/>

        {contextHolder}
        <Spin spinning={loading} tip="Loading..." size="large">
    <Layout>

        <Header className='header-style' >
          {/* Importing from the another component */}
          <HeaderFile/>
        </Header>

        <Content>
         
<div className='banner-tp'>
            <img src="/contact-tp-bnr.png" />
              <div className="banner-content">
                <img
                src="/frameImg.png"
                alt="Overlay Image"
                className='top-img'
                />
               <div className="image-content-dis">
                <BlurText
                  text="Contacts"
                  delay={150}
                  animateBy="words"
                  direction="top"
                  className="toptextone"  // example (if using Tailwind)
                />
                <BlurText
                  text="Let's Grow Together"
                  delay={300}
                  animateBy="words"
                  direction="top"
                
                />
              </div>
              </div>             
           </div>
            {!isMobile && (
            <Row className='contbfr' justify="center" align="top" style={{padding: isMobile ? "0 5%" : "0 10%", background:"#fff", paddingBottom:"5rem", paddingTop:"4rem"}}>
                <Col span={14} >

                <h1 className='headings mrgbtm'>
                Get In Touch
                </h1>
                <ContactForm />
               

                </Col>
                <Col span={10} style={{paddingLeft:"4rem"}}>
                    <p className='headings' style={{marginBottom:"2rem"}}>
                        Contact Details
                    </p>
                    <p className='contact-detail-heading'>Drop us an email with your request, and we will get back to you</p>
                    <span className='contact-style'>
                    <MailFilled className='contact-detail-icon'/>
                    <p className='contact-detail'>mounabn.business@gmail.com</p>
                    </span>                  

                   
                </Col>
            </Row>
            )}

            {isMobile && (
                <div className='contbfr' style={{padding: "1rem 5%"}}>
                    <h1 className='headings'>
                    Get In Touch
                    </h1>
                   
                    <ContactForm />

                  

                    <div style={{marginBottom:"1rem", marginTop:"2.5rem"}}>
                        <p className='headings' style={{marginBottom:"2rem"}}>
                        Contact Details
                        </p>

                        <p className='contact-detail-heading'>Drop us an email with your request, and we will get back to you.</p>
                        <span className='contact-style'>
                            <MailFilled className='contact-detail-icon'/>
                            <p className='contact-detail'>mounabn.business@gmail.com</p>
                        </span>                      

                       
                        </div>

                </div>
            )}


        </Content>

        <Footer style={{ position: 'relative', overflow: 'hidden' }}>
        <FooterFile/>
      </Footer>

    </Layout>
    </Spin>
    </div>
  )
}

export default Contact